import * as types from './types';

export function updateDownPayment(newPrice) {
	return {
		type: types.UPDATE_DOWN_PAYMENT,
		payload: {
			downPayment: newPrice
		}
	};
}

export function updateAPR(newAPR) {
	return {
		type: types.UPDATE_APR,
		payload: {
			apr: newAPR
		}
	};
}

export function updateSelectedAprTerm(newTerm) {
	return {
		type: types.UPDATE_SELECTED_APR_TERM,
		payload: {
			term: newTerm
		}
	};
}

export function resetCalculator() {
	return {
		type: types.RESET_CALCULATOR
	};
}



// WEBPACK FOOTER //
// ./src/actions/updateCalculator.js